// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.chart-panel {
          background-color: #fff;
          opacity: 0.85;
          position: absolute;
          top: 1px;
}
  `, "",{"version":3,"sources":["webpack://./src/components/Modals/charts-modal/ChartPanel.vue"],"names":[],"mappings":";AAKM;UACI,sBAAsB;UACtB,aAAa;UACb,kBAAkB;UAClB,QAAQ;AACZ","sourcesContent":["<template>\n    <div class=\"chart-panel\" />\n  </template>\n  \n  <style>\n      .chart-panel {\n          background-color: #fff;\n          opacity: 0.85;\n          position: absolute;\n          top: 1px;\n      }\n  </style>\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
